module.exports = __webpack_public_path__ + "static/img/gzh_code.5cc80b5.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gzh_code.jpeg
// module id = iF1h
// module chunks = 15